import { FormControl, FormHelperText, InputLabel, makeStyles, MenuItem, Select, Typography } from '@material-ui/core'
import React from 'react'
const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
    // border: 'none',
    // color: theme.palette.common.black,
    // '&:focus': {
    //   outline: 'none',
    // },
    [theme.breakpoints.up('md')]: {
      width: '100%',
      // fontSize: '14px',
      marginTop: '22px',
      fontSize: '16px',
      // padding: '8.5px',
    },
  },
  input: {
    width: '90%',
    // marginTop: '22px',
    fontSize: '16px',
  },
}))
export default function CustomSelect({ handleChange, value, label, className, options, sort, placeholder, leadStatus, setForm, form, formCheck, name, disabled, shrink, errorMessage, onKeyDown }) {
  const classes = useStyles()
  const handleOnChange = (event) => {
    handleChange(event.target.value)
  }

  const handleChangeNew = (event) => {
    //console.log('Value : ', event.target.value)
    setForm({ ...form, [event.target.name]: event.target.value })
  }
  // // const renderClass = leadStatus ? classes.lead + ' ' + ' form-select' : classes.select + ' ' + 'form-select'
  // //console.log('LABEL : ', label)
  // //console.log('OPTIONS  : ', options)
  return (
    <div>
      <FormControl className={className ? `${className} ${classes.input}` : classes.input} style={{ marginTop: '2px' }}>
        {/* {label && <label htmlFor=""> {label} </label>} */}
        {/* {shrink ? <InputLabel shrink>{label}</InputLabel> : <InputLabel>{label}</InputLabel>} */}
        <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{label}</Typography>

        <Select
          // variant="outlined"
          name={name}
          onChange={formCheck ? handleChangeNew : handleOnChange}
          value={value}
          className={className ? `${className} ${classes.input}` : classes.input}
          label={label}
          disabled={disabled}
          InputLabelProps={{ shrink: false }}
          onBlur={onKeyDown}
          error={errorMessage ? true : false}
        >
          <MenuItem value="" disabled>
            {' '}
            <em>{placeholder ? placeholder : label}</em>{' '}
          </MenuItem>
          {label === 'Ranks'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))
            : label === 'Region *' ||
              label === 'Zone *' ||
              label === 'State *' ||
              label === 'District *' ||
              label === 'District' ||
              label === 'City *' ||
              label === 'Template Category' ||
              label === 'Select Channel Type' ||
              label === 'Area *' ||
              label === 'Select Sub Category' ||
              label === 'Region' ||
              label === 'State' ||
              label === 'Scheme' ||
              label === 'From' ||
              label === 'To' ||
              label === 'City' ||
              label === 'Store' ||
              label === 'Customer Type' ||
              label === 'Assign Store *' ||
              label === 'Area' ||
              label === 'Target For' ||
              label === 'Leave Type' ||
              label === 'Type' ||
              label === 'Tax' ||
              label === 'Zone' ||
              label === 'Customer'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item._id} key={index}>
                  {item.name}
                </MenuItem>
              ))
            : label === 'Status' ||
              label === 'Employment Type ' ||
              label === 'Rank' ||
              label === 'Sale Type' ||
              label === 'Target For' ||
              label === 'Target Type' ||
              label === 'Target Based On' ||
              label === 'Language' ||
              label === 'Timezone' ||
              label === 'Financial Year Start From' ||
              label === 'Working Days From' ||
              label === 'Working Days To' ||
              label === 'Holiday From' ||
              label === 'Validity' ||
              label === 'Scheme Based On' ||
              label === 'Holiday To' ||
              label === 'Currency'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.label}
                </MenuItem>
              ))
            : label === 'Select Position'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item._id} key={index}>
                  {item.positionName}
                </MenuItem>
              ))
            : label === 'Check In'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item.name} key={index}>
                  {item.name}
                </MenuItem>
              ))
            : leadStatus
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item} key={index}>
                  {item}
                </MenuItem>
              ))
            : label === 'Reporting Manager'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item._id} key={index}>
                  {item.firstName}
                </MenuItem>
              ))
            : label === 'Identity Proof' || label === 'Rank' || label === 'Sub Type'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item} key={index}>
                  {item}
                </MenuItem>
              ))
            : label === 'Product'
            ? options &&
              options.map((item, index) => (
                <MenuItem value={item._id} key={index}>
                  {item.name}
                </MenuItem>
              ))
            : options &&
              options.map((item, index) => (
                <MenuItem value={item._id} key={index}>
                  {item.categoryName}
                </MenuItem>
              ))}
        </Select>
        <FormHelperText style={{ color: 'red' }}>{errorMessage}</FormHelperText>
      </FormControl>
    </div>
  )
}
